import { useEffect, useRef, useState } from 'react'

import styled from '@emotion/styled'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles'

const Container = styled.div`
  display: flex;
  flex-direction: column;

  // 手機瀏覽器設置100vh會被瀏覽器本身上下方的元件覆蓋
  // 改用此方案
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow-y: auto;
  overflow-x: hidden;
`

const Grow = styled.div`
  flex-grow: 1;
  ${(props) => (props.fixHeight ? 'min-height: 100%' : '')};
  ${(props) => (props.fixHeight ? 'display: flex' : '')};
  ${(props) => (props.fixHeight ? 'flex-direction: column' : '')};
`

const Layout = ({
  header,
  stickyHeader,
  footer,
  stickyFooter,
  fixContentHeight,
  children,
  contentWrapperRef,
  contentWrapperId,
}) => {
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'))

  // 無法直接使用 contentWrapperRef，所以多宣告 scopedContentWrapperRef 在 Layout 裡使用
  const scopedContentWrapperRef = useRef(null)
  const refHandler = (el) => {
    if (contentWrapperRef) {
      contentWrapperRef.current = el
    }
    if (scopedContentWrapperRef) {
      scopedContentWrapperRef.current = el
    }
  }

  return (
    <Container>
      {!!stickyHeader && (
        <>
          {typeof stickyHeader === 'function' ? (
            stickyHeader()
          ) : (
            <>{stickyHeader}</>
          )}
        </>
      )}
      <ContentWrapper id={contentWrapperId} ref={refHandler}>
        {!!header && (
          <>{typeof header === 'function' ? header() : <>{header}</>}</>
        )}
        <Grow fixHeight={fixContentHeight}>{children}</Grow>
        {!!footer && (
          <>{typeof footer === 'function' ? footer() : <>{footer}</>}</>
        )}
      </ContentWrapper>
      {!!stickyFooter && (
        <>
          {typeof stickyFooter === 'function' ? (
            stickyFooter()
          ) : (
            <>{stickyFooter}</>
          )}
        </>
      )}
    </Container>
  )
}

Layout.defaultProps = {
  contentWrapperId: null,
}

export default Layout
